export const togglePreloader = (data) => ({
  type: 'TOGGLE_PRELOADER',
  data
})


// WEBPACK FOOTER //
// ./src/redux/actions/App/AppActions.js